export default [
  {
    path: '/firms',
    component: () => import('@argon/app/components/AppLayout'),
    props: { nav: 'organizations' },
    children: [
      {
        path: '',
        name: 'firms',
        component: () => import('./views/Firms'),
        props: true,
        meta: {
          perimeterAction: 'read'
        },
        children: [
          {
            path: 'new',
            name: 'newFirm',
            component: () => import('./views/ModalFirm'),
            props: true,
            meta: {
              perimeterAction: 'read'
            }
          }
        ]
      },
      {
        path: ':firmId',
        name: 'firmPage',
        component: () => import('./views/FirmPage'),
        props: true,
        meta: {
          perimeterAction: 'read'
        },
        children: [
          {
            path: 'edit',
            name: 'editFirm',
            component: () => import('./views/ModalFirm'),
            props: true,
            meta: {
              perimeterAction: 'read'
            }
          },
          {
            path: 'agencies/:agencyId',
            name: 'editAgency',
            component: () => import('./views/ModalAgency'),
            props: true,
            meta: {
              perimeterAction: 'read'
            }
          }
        ]
      }
    ]
  }
]
